import React from 'react';
import { Icon } from '../../../icons/icons';


const PaymentItem = ({ idFocus, nameplaceholder, icon, name }) => {
    return (
        <div className='border py-3 px-4 flex justify-center items-center gap-x-2 sm:gap-x-7'>
            <label htmlFor={idFocus} className='font-semibold sm:w-[30%] w-[40%] text-[12px] sm:text-[16px]'>{nameplaceholder}</label>
            <div className="flex items-center w-full">
                {icon &&
                    <span className='bg-[#f8f9fa] py-2 px-[0.75rem] rounded-l border'>
                        <Icon name={icon} />
                    </span>
                }
                <input type="text" name={name} className="border rounded-r w-full px-3 py-2 placeholder:text-black" id={idFocus} />
            </div>
        </div>
    );
};

export default PaymentItem;